import { useFilePreviewWithPresigned } from '@/hooks/useFilePreviewWithPresigned'
import DownLoadIcons from '@/icons/DownLoadIcons'
import EyeIcons from '@/icons/EyeIcons'
import LockIcons from '@/icons/LockIcons'
import { Attachment } from '@/modules/Upload/types'
import { useCallback } from 'react'
import { Typogaphy } from 'vnetwork-ui'

interface SampleAttachmentProps {
    attachment: any
}
const SampleAttachment = ({ attachment }: SampleAttachmentProps) => {
    const { openFilePreview, downloadFileWithPresigned } =
        useFilePreviewWithPresigned()

    const handlePreview = useCallback(
        async (attachment: Attachment) => {
            await openFilePreview(attachment)
        },
        [openFilePreview]
    )

    const handleDownload = useCallback(
        async (attachment: Attachment) => {
            await downloadFileWithPresigned(attachment)
        },
        [downloadFileWithPresigned]
    )
    return (
        <div
            key={attachment.attachment_id}
            className={`relative backdrop-blur-sm rounded border px-2 py-1.5 transition-all duration-200 flex items-center gap-2 ${
                attachment.attachment_closed
                    ? 'bg-gray-200/50 border-gray-300/40 opacity-60'
                    : 'bg-white/30 border-white/40 hover:bg-white/50'
            }`}
        >
            {/* File name */}
            <Typogaphy
                className={`text-[10px] leading-tight truncate flex-1 min-w-0 ${
                    attachment.attachment_closed
                        ? 'text-gray-500'
                        : 'text-gray-700'
                }`}
            >
                {attachment.attachment_file_name}
            </Typogaphy>

            {/* Action buttons */}
            {!attachment.attachment_closed && (
                <div className="flex items-center gap-0.5 flex-shrink-0">
                    <button
                        type="button"
                        onClick={() => handlePreview(attachment)}
                        className="text-blue-600 hover:bg-blue-100 rounded p-0.5"
                    >
                        <EyeIcons className="w-3 h-3" />
                    </button>
                    <button
                        type="button"
                        onClick={() => handleDownload(attachment)}
                        className="text-green-600 hover:bg-green-100 rounded p-0.5"
                    >
                        <DownLoadIcons className="w-3 h-3" />
                    </button>
                </div>
            )}

            {/* Lock Icon for closed attachments */}
            {attachment.attachment_closed && (
                <LockIcons className="w-3 h-3 text-red-500 flex-shrink-0" />
            )}
        </div>
    )
}

export default SampleAttachment
